export default class Movie {
    constructor() {
        this.player = null;
        this.bgPlayer = [];
        this.init();
    }

    init() {
        const $modalbtn = document.querySelector(".js-modalmovie_open");

        if ($modalbtn !== null) {
            this.setup();
            this.eventBind();
        }
    }

    resetEvent() {
        this.eventBind("reset");
    }

    setup() {
        const tag = document.createElement("script");
        const videoBtns = [...document.querySelectorAll(".js-modalmovie_open")];

        tag.src = "https://www.youtube.com/iframe_api";
        const firstScriptTag = document.getElementsByTagName("script")[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

        window.onYouTubeIframeAPIReady = () => {
            this.player = new YT.Player("moviePlayer", {
                height: "100%",
                width: "100%",
                videoId: videoBtns[0].getAttribute("data-videoid"), //デフォルト
                events: {
                    onStateChange: this.onStateChange.bind(this),
                    onError: this.onError,
                },
            });
        };
    }

    onError(e) {
        console.log(e);
    }

    onBgPlayerReady(e) {
        e.target.mute();
        e.target.playVideo();
    }
    onBgPlayerStateChange(e) {
        //END時にもう一度再生させる(ENDEDが変わらないので強制play)
        e.target.playVideo();
    }

    onStateChange(e) {
        //プレミア公開も考慮してバッファリング(3)のタイミングに変更。そしてsetTimeoutさせる。
        if (e.data === 3) {
            setTimeout(() => {
                document.querySelector(".c-modal_movie__iframewrap").style.opacity = 1;
            }, 200);
        }
    }

    eventBind(resetOption) {
        const openbuttons = [...document.querySelectorAll(".js-modalmovie_open")];
        const closebuttons = [...document.querySelectorAll(".js-modal_close")];
        const videowrap = document.querySelector(".c-modal_movie__iframewrap");
        const changebtn = [...document.querySelectorAll(".js-modal_movie_change")];

        const handleClose = () => {
            this.player.stopVideo();
            if (videowrap) {
                //クローズ時に非表示に。
                videowrap.style.opacity = 0;
            }
        };

        const handleOpen = (e) => {
            const videoID = e.currentTarget.getAttribute("data-videoID");
            this.loadVideo(videoID);

            //navActive
            changebtn.forEach((el) => {
                el.classList.remove("-active");

                if (el.getAttribute("data-videoID") === videoID) {
                    el.classList.add("-active");
                }
            });
        };

        changebtn.forEach((el) => {
            el.addEventListener("click", handleOpen);
        });

        openbuttons.forEach((el) => {
            resetOption && el.removeEventListener("click", handleOpen);
            el.addEventListener("click", handleOpen);
        });

        closebuttons.forEach((el) => {
            resetOption && el.removeEventListener("click", handleClose);
            el.addEventListener("click", handleClose);
        });
    }

    loadVideo(id) {
        //デフォルトでautoplayされる。
        this.player.loadVideoById({ videoId: id });
    }
}
